(function() {

  var ME_TOKEN   = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiIxIiwianRpIjoiNmY1MmIyNjMyMjBmMTBhYWY4NDg5MGFhNTg3MjFhYTdjMzMwZGI4NmYxMTc0ZDc1MjBhMmEzYTI1MGIzZDc2ZGRlYzljODYwMTQwNGRmMTAiLCJpYXQiOjE3Nzk3MDgzMTUuNTYyMDYsIm5iZiI6MTc3OTcwODMxNS41NjIwNjEsImV4cCI6MTgxMTI0NDMxNS41NDgyNTgsInN1YiI6IjlhZTBmZmE3LWRjMDctNGZjOC04OWE0LTg2MGU2MDFmZTcxNCIsInNjb3BlcyI6WyJjYXJ0LXJlYWQiLCJjYXJ0LXdyaXRlIiwiY29tcGFuaWVzLXJlYWQiLCJjb21wYW5pZXMtd3JpdGUiLCJjb3Vwb25zLXJlYWQiLCJjb3Vwb25zLXdyaXRlIiwibm90aWZpY2F0aW9ucy1yZWFkIiwib3JkZXJzLXJlYWQiLCJwcm9kdWN0cy1yZWFkIiwicHJvZHVjdHMtZGVzdHJveSIsInByb2R1Y3RzLXdyaXRlIiwicHVyY2hhc2VzLXJlYWQiLCJzaGlwcGluZy1jYWxjdWxhdGUiLCJzaGlwcGluZy1jYW5jZWwiLCJzaGlwcGluZy1jaGVja291dCIsInNoaXBwaW5nLWNvbXBhbmllcyIsInNoaXBwaW5nLWdlbmVyYXRlIiwic2hpcHBpbmctcHJldmlldyIsInNoaXBwaW5nLXByaW50Iiwic2hpcHBpbmctc2hhcmUiLCJzaGlwcGluZy10cmFja2luZyIsImVjb21tZXJjZS1zaGlwcGluZyIsInRyYW5zYWN0aW9ucy1yZWFkIiwidXNlcnMtcmVhZCIsInVzZXJzLXdyaXRlIiwid2ViaG9va3MtcmVhZCIsIndlYmhvb2tzLXdyaXRlIiwid2ViaG9va3MtZGVsZXRlIiwidGRlYWxlci13ZWJob29rIl19.aqA2x0p0hDm0DQX6lrXl4KWnYPDYGp_jmreymQLFvcFBfIrhK8qiIGt7-zfjBDi-xxIMdSyeGPbTeRUfuO7XfC1Ot-3nra--ETBuysnvGM2tojt_NrH_vbujp1TlkbggAPPc4RkND2LfSuoLSp3RKeFfQ79-BYnnydbzfe9_3M726zIHR6O4NBKVY_njj2mfggNqnOi1TIE4TuSHfHzKxo3LecO0xkoD8mgiLa3gRJWYBEve-HQe7wkykiOj4K_VTBcmALsaK1zPOR28pr1MSJr9aoWQm0_4nQKZz_vXv5avBHV4lmwjv1C2dXpCfur4FaHouGzFgCxWxAvgnPWx4jA-OvZW2-ymDQ_CIGUeHEu68T5j89cTtMML62dkJRsfh5_4jSMw5ewwyEqaacbl5cESRjOKwvvko2_P0V6DlkrJ-CKeLL63clQOk7zv1TnzMA_u0Mx6XRu0KNPvytkU3VFMbrsfujGCPMNeaJhUhmZSeQhCRSUS1gary4hBYkbDmUf7tHgrpTvT9jaV8wIO92rTr_-7pkluNnlqiDYDb8FnUFy_U3b3Tsyc9iZXlETZzcpR6iC8-k03E990cAN116N4OT3JtS-7KHXl-SfyvOWXYPBEdj2HSMgn_BdPuse4llq5F5YWfpOoue1nvHh0JRIz0HBazNozIEInq0DuP5w';
  var CEP_ORIGEM = '71503511';
  var ME_API_URL = 'https://frenet-proxy.joaovitor.workers.dev/';

  var PKG_LENGTH     = 16;
  var PKG_HEIGHT     = 4;
  var PKG_WIDTH      = 11;
  var PKG_WEIGHT_MIN = 0.3;

  var VALOR_FRETE_GRATIS = 600.00;
  var FRETE_FIXO_PAC     = 9.90;
  var FAIXAS_FRETE_FIXO  = [
    [1000000,  19999999],  // SP
    [20000000, 28999999],  // RJ
    [29000000, 29999999],  // ES
    [30000000, 39999999],  // MG
    [40000000, 48999999],  // BA
  ];

  function cepTemFreteFixo(cepRaw) {
    var num = parseInt(cepRaw, 10);
    for (var i = 0; i < FAIXAS_FRETE_FIXO.length; i++) {
      if (num >= FAIXAS_FRETE_FIXO[i][0] && num <= FAIXAS_FRETE_FIXO[i][1]) {
        return true;
      }
    }
    return false;
  }

  function esc(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function initWidget(root) {
    if (root.dataset.frenetReady === '1') return;
    root.dataset.frenetReady = '1';

    var input    = root.querySelector('[data-frenet-cep]');
    var btn      = root.querySelector('[data-frenet-btn]');
    var loading  = root.querySelector('[data-frenet-loading]');
    var errorBox = root.querySelector('[data-frenet-error]');
    var results  = root.querySelector('[data-frenet-results]');
    var list     = root.querySelector('[data-frenet-list]');

    if (!input || !btn) return;

    var PRODUCT_WEIGHT = Math.max(parseFloat(root.dataset.productWeight) || 0, PKG_WEIGHT_MIN);
    var PRODUCT_PRICE  = parseFloat(root.dataset.productPrice) || 0;
    var VARIANT_ID     = root.dataset.variantId;
    var CORREIOS_LOGO  = root.dataset.correiosLogo;

    function show(el) { if (el) el.classList.add('active'); }
    function hide(el) { if (el) el.classList.remove('active'); }

    function showError(msg) {
      errorBox.textContent = msg;
      show(errorBox);
    }

    function getQuantidade() {
      var scope = root.closest('product-form, .product-info, form') || document;
      var qtyInput = scope.querySelector('input[name="quantity"], input[data-quantity-input], .quantity__input');
      if (qtyInput) {
        var val = parseInt(qtyInput.value, 10);
        return isNaN(val) || val < 1 ? 1 : val;
      }
      return 1;
    }

    input.addEventListener('input', function() {
      var v = this.value.replace(/\D/g, '').slice(0, 8);
      this.value = v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
    });

    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') calcular();
    });

    btn.addEventListener('click', calcular);

    function calcular() {
      var cepRaw = input.value.replace(/\D/g, '');

      if (cepRaw.length !== 8) {
        showError('Por favor, informe um CEP válido com 8 dígitos.');
        return;
      }

      hide(errorBox);
      hide(results);
      show(loading);
      btn.disabled = true;

      var quantidade  = getQuantidade();
      var totalPedido = PRODUCT_PRICE * quantidade;
      var freteGratis = totalPedido >= VALOR_FRETE_GRATIS;
      var freteFixo   = cepTemFreteFixo(cepRaw);

      var payload = {
        from: { postal_code: CEP_ORIGEM },
        to:   { postal_code: cepRaw },
        products: [{
          id:              VARIANT_ID,
          width:           PKG_WIDTH,
          height:          PKG_HEIGHT,
          length:          PKG_LENGTH,
          weight:          PRODUCT_WEIGHT,
          insurance_value: PRODUCT_PRICE,
          quantity:        quantidade
        }],
        options: {
          insurance_value: totalPedido || 0,
          receipt:  false,
          own_hand: false
        },
        services: '1,2,17'
      };

      fetch(ME_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + ME_TOKEN
        },
        body: JSON.stringify(payload)
      })
      .then(function(res) {
        if (!res.ok) throw new Error('Erro na comunicação com a transportadora.');
        return res.json();
      })
      .then(function(data) {
        hide(loading);
        btn.disabled = false;

        if (!Array.isArray(data) || data.length === 0) {
          showError('Não encontramos opções de entrega para este CEP.');
          return;
        }

        var services = data.filter(function(s) {
          return !s.error && s.price !== undefined;
        });

        if (services.length === 0) {
          showError('Não há opções disponíveis para este CEP no momento.');
          return;
        }

        services = services.map(function(s) {
          var isPac = (s.name || '').toLowerCase().includes('pac');
          if (isPac && freteGratis) return Object.assign({}, s, { price: '0.00' });
          if (isPac && freteFixo)   return Object.assign({}, s, { price: FRETE_FIXO_PAC.toFixed(2) });
          return s;
        });

        services.sort(function(a, b) {
          return parseFloat(a.price) - parseFloat(b.price);
        });

        renderResults(services);
      })
      .catch(function(err) {
        hide(loading);
        btn.disabled = false;
        showError('Não foi possível calcular o frete. Tente novamente.');
        console.error('[MelhorEnvio]', err);
      });
    }

    function renderResults(services) {
      list.innerHTML = '';

      services.forEach(function(s) {
        var price    = parseFloat(s.price);
        var isFree   = price === 0;
        var priceStr = isFree ? 'Grátis' : 'R$\u00a0' + price.toFixed(2).replace('.', ',');

        var prazo = parseInt(s.delivery_time, 10);
        var prazoStr = prazo === 0
          ? 'Entrega hoje'
          : prazo === 1
            ? 'Entrega em 1 dia útil'
            : 'Entrega em ' + prazo + ' dias úteis';

        var nome = (s.name || '').toLowerCase();

        // Exibe "Entrega Expressa" no lugar de "Sedex"
        var nomeExibido = nome.includes('sedex') ? 'Entrega Expressa' : (s.name || '');

        var logoHTML = '';
        if (nome.includes('pac') || nome.includes('sedex') || nome.includes('mini')) {
          logoHTML = '<img src="' + CORREIOS_LOGO + '" style="width:36px;height:36px;object-fit:contain;" />';
        } else {
          var sigla = (s.name || '?').slice(0, 3).toUpperCase();
          logoHTML = '<div style="width:36px;height:36px;background:#f0f0f0;border-radius:6px;display:flex;align-items:center;justify-content:center;font-size:9px;font-weight:700;color:#555;">' + sigla + '</div>';
        }

        var item = document.createElement('div');
        item.className = 'frenet-widget__option';
        item.innerHTML =
          '<div class="frenet-widget__option-left">' +
            '<div class="frenet-widget__carrier-badge">' + logoHTML + '</div>' +
            '<div>' +
              '<div class="frenet-widget__service-name">' + esc(nomeExibido) + '</div>' +
              '<div class="frenet-widget__service-deadline">' + prazoStr + '</div>' +
            '</div>' +
          '</div>' +
          '<div class="frenet-widget__option-price' + (isFree ? ' free' : '') + '">' + priceStr + '</div>';

        list.appendChild(item);
      });

      show(results);
    }
  }

  function initAll(scope) {
    var widgets = (scope || document).querySelectorAll('[data-frenet-widget]');
    for (var i = 0; i < widgets.length; i++) {
      initWidget(widgets[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(); });
  } else {
    initAll();
  }

  if (window.MutationObserver) {
    var observer = new MutationObserver(function(mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var n = 0; n < added.length; n++) {
          var node = added[n];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-frenet-widget]')) {
            initWidget(node);
          } else if (node.querySelectorAll) {
            initAll(node);
          }
        }
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

})();